import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { CreateAppPage } from '@/routes/apps/create-app/page'

export const CreateApp = () => {
  return (
    <PageErrorBoundary>
      <CreateAppPage />
    </PageErrorBoundary>
  )
}
